module.exports = "/wp-content/themes/lanthiaresort/modules/public/font/a1f868fe40a4547992a515e4059f8717.eot";